// Elixir Logo
const ELIXIR_LOGO = "https://www.productelixir-ai.tech/assets/Elixirlogo_1769893492761-BCKEFavv.png";

export const Footer = () => {
  const productLinks = [
    { label: "ElixirID Core", href: "#" },
    { label: "Industries", href: "#industries" },
    { label: "Features", href: "#features" },
  ];

  const companyLinks = [
    { label: "Product Elixir", href: "https://www.productelixir-ai.tech", external: true },
    { label: "HealthGuardhq", href: "https://healthguardhq.tech", external: true },
    { label: "Documentation", href: "#" },
  ];

  return (
    <footer 
      className="py-16 sm:py-20 lg:py-24 px-6 lg:px-10 border-t border-slate-900 bg-[#01040D]"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row justify-between items-start gap-12 lg:gap-20 mb-16 lg:mb-24">
          {/* Logo & Description */}
          <div className="space-y-6 lg:space-y-8 max-w-sm">
            <div className="flex items-center gap-4">
              <img 
                src={ELIXIR_LOGO} 
                alt="ElixirID Logo" 
                className="h-10 w-10 lg:h-12 lg:w-12 object-contain"
              />
              <span 
                className="text-2xl lg:text-3xl font-extrabold tracking-tighter text-white uppercase"
                data-testid="footer-logo"
              >
                Elixir<span className="text-violet-400">ID</span>
              </span>
            </div>
            <p className="text-slate-500 text-sm leading-relaxed">
              The Agentic Entitlement Engine for enterprise-scale AI governance. Built for regulated industries, designed for compliance.
            </p>
          </div>
          
          {/* Links */}
          <div className="grid grid-cols-2 gap-12 lg:gap-24">
            {/* Product */}
            <div>
              <h4 
                className="text-[9px] sm:text-[10px] font-extrabold uppercase tracking-[0.4em] sm:tracking-[0.5em] text-white mb-6 lg:mb-8"
                data-testid="footer-product-heading"
              >
                Product
              </h4>
              <ul className="space-y-4 lg:space-y-5 text-xs font-semibold text-slate-500 uppercase tracking-[0.15em] sm:tracking-[0.2em]">
                {productLinks.map((link, index) => (
                  <li key={index}>
                    <a 
                      href={link.href}
                      className="hover:text-violet-400 cursor-pointer transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            
            {/* Company */}
            <div>
              <h4 
                className="text-[9px] sm:text-[10px] font-extrabold uppercase tracking-[0.4em] sm:tracking-[0.5em] text-white mb-6 lg:mb-8"
                data-testid="footer-company-heading"
              >
                Company
              </h4>
              <ul className="space-y-4 lg:space-y-5 text-xs font-semibold text-slate-500 uppercase tracking-[0.15em] sm:tracking-[0.2em]">
                {companyLinks.map((link, index) => (
                  <li key={index}>
                    <a 
                      href={link.href}
                      target={link.external ? "_blank" : undefined}
                      rel={link.external ? "noopener noreferrer" : undefined}
                      className="hover:text-violet-400 cursor-pointer transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="flex flex-col sm:flex-row justify-between items-center gap-6 lg:gap-10 pt-12 lg:pt-16 border-t border-slate-900">
          <p className="text-slate-600 text-[8px] sm:text-[9px] font-extrabold uppercase tracking-[0.3em] sm:tracking-[0.5em]">
            © 2025 Product Elixir AI · ElixirID Core Beta
          </p>
        </div>
      </div>
    </footer>
  );
};
